import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';

export const art = {
    background: colors.plumLt,
    image: () => <ImageWrapper image={<Illustration src='calendar-lady' />} width={210} />,
} as const;
